import { Button, Icon, Popover, Popper, Typography } from '@thimble/core-lib';
import React, { useRef } from 'react';

const { Text } = Typography;

const Tooltip: React.FC<{
  /**
   * @deprecated
   * not longer recommended
   */
  from?: string;
}> = props => {
  const buttonRef = useRef<HTMLDivElement>(null);

  return (
    <span style={{ display: 'inline-block', marginLeft: 8 }}>
      <Popover
        popup={
          <div style={{ maxWidth: 250, padding: '8px 20px' }} ref={buttonRef}>
            <Text preset="description" color="black">
              {props.children}
            </Text>
          </div>
        }
        placement="bottom"
        popupPreset={Popper.presets.PRESET_TOOLTIP}
        trigger="hover"
      >
        <Button.Text style={{ verticalAlign: 'middle' }}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
              stroke="#DDDDDD"
              strokeWidth="2"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.166 11.166C13.992 10.438 14.356 9.696 14.356 8.814C14.356 7.204 13.012 6 11.206 6C9.33 6 8 7.344 8 9.192H9.624C9.638 8.268 10.31 7.568 11.192 7.568C12.06 7.568 12.69 8.184 12.69 8.94C12.69 9.486 12.326 10.018 11.64 10.536C10.772 11.194 10.296 11.922 10.296 12.58V13.07H11.934V12.734C11.934 12.1996 12.4354 11.7808 12.894 11.3978C12.988 11.3192 13.0803 11.2422 13.166 11.166ZM11.164 14.092C10.576 14.092 10.128 14.554 10.128 15.114C10.128 15.674 10.576 16.136 11.164 16.136C11.752 16.136 12.2 15.674 12.2 15.114C12.2 14.554 11.752 14.092 11.164 14.092Z"
              fill="#DDDDDD"
            />
          </svg>
        </Button.Text>
      </Popover>
    </span>
  );
};

export default Tooltip;
